export default "__VITE_ASSET__ClLFAz7k__"